import { css } from "@styled-system/css";

export const buttonWrapperClass = css({
	mt: "2",
});
